import React from "react";
import {Tooltip} from "@mui/material";
import {IonIcon} from "@ionic/react";
import {handLeft} from "ionicons/icons";
import {WithTranslation, withTranslation} from "react-i18next";

/**
 * Displays a freehand icon with a tooltip.
 * @author Alizée Grand
 * @version 1.1
 * @creation 31/05/2022
 * @last_update 11/07/2022
 **/
class DataFilledManually extends React.Component<WithTranslation> {

    render() {

        return (

            <Tooltip title={this.props.t("display.data-filled-manually.tooltip")}>
                <span>
                    <IonIcon icon={handLeft} color="primary"/>
                    &nbsp;
                </span>
            </Tooltip>


        );

    };

}

export default withTranslation()(DataFilledManually);
